import { render, staticRenderFns } from "./AccessPolicyEdit.vue?vue&type=template&id=23734fb0&"
import script from "./AccessPolicyEdit.vue?vue&type=script&lang=ts&"
export * from "./AccessPolicyEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports